// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/src/assets/sidebar-background-image.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar-wrapper * {
  color: #ffffff;
}
.sidebar-content img {
  width: 150px;
}
.sidebar-wrapper {
  background: #1B3382;
  padding: 5rem;
  position: relative;
  width: 25%;
  height: auto;
  border-radius: 24px;
}

.sidebar-wrapper:after {
  content: "";
  position: absolute;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: cover;
  background-position-y: 100%;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
}

.sidebar-content {
  position: relative;
  z-index: 1;
}

.sidebar-content h1 {
  margin-top: 5rem;
  font-size: 3rem;
  font-weight: 700;
  line-height: 1.2;
}

@media (max-width: 1440px) {
  .sidebar-wrapper:after {
    background-size: contain;
  }
  .sidebar-wrapper {
    width: 30%;
  }
}
@media (max-width: 1150px) {
  .sidebar-wrapper {
    padding: 5rem 3rem;
  }
}

@media (max-width: 768px) {
  .sidebar-wrapper {
    width: 100%;
    padding: 5rem 3rem 3rem;
  }
  .sidebar-wrapper:after {
    background: none;
  }
  .sidebar-content {
    text-align: center;
  }
  .step-info p {
    display: none;
  }
  .step-info h2 {
    font-size: 1.5rem;
  }
  .steps-wrapper {
    display: none!important;
  }
}
@media (max-width: 576px) {
  .sidebar-content {
    text-align: left;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Book Demo Sidebar/Sidebar.css"],"names":[],"mappings":"AAAA;EACE,cAAc;AAChB;AACA;EACE,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mDAAyD;EACzD,4BAA4B;EAC5B,sBAAsB;EACtB,2BAA2B;EAC3B,SAAS;EACT,OAAO;EACP,QAAQ;EACR,MAAM;AACR;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,WAAW;IACX,uBAAuB;EACzB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;EACA;IACE,iBAAiB;EACnB;EACA;IACE,uBAAuB;EACzB;AACF;AACA;EACE;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".sidebar-wrapper * {\n  color: #ffffff;\n}\n.sidebar-content img {\n  width: 150px;\n}\n.sidebar-wrapper {\n  background: #1B3382;\n  padding: 5rem;\n  position: relative;\n  width: 25%;\n  height: auto;\n  border-radius: 24px;\n}\n\n.sidebar-wrapper:after {\n  content: \"\";\n  position: absolute;\n  background: url(/src/assets/sidebar-background-image.svg);\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position-y: 100%;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  top: 0;\n}\n\n.sidebar-content {\n  position: relative;\n  z-index: 1;\n}\n\n.sidebar-content h1 {\n  margin-top: 5rem;\n  font-size: 3rem;\n  font-weight: 700;\n  line-height: 1.2;\n}\n\n@media (max-width: 1440px) {\n  .sidebar-wrapper:after {\n    background-size: contain;\n  }\n  .sidebar-wrapper {\n    width: 30%;\n  }\n}\n@media (max-width: 1150px) {\n  .sidebar-wrapper {\n    padding: 5rem 3rem;\n  }\n}\n\n@media (max-width: 768px) {\n  .sidebar-wrapper {\n    width: 100%;\n    padding: 5rem 3rem 3rem;\n  }\n  .sidebar-wrapper:after {\n    background: none;\n  }\n  .sidebar-content {\n    text-align: center;\n  }\n  .step-info p {\n    display: none;\n  }\n  .step-info h2 {\n    font-size: 1.5rem;\n  }\n  .steps-wrapper {\n    display: none!important;\n  }\n}\n@media (max-width: 576px) {\n  .sidebar-content {\n    text-align: left;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
